import { LazyImagePropertiesType } from "@website/ui/lazy-image/lazy-image.types";
import pick from "lodash-es/pick";
import toString from "lodash-es/toString";
import { FC, memo, useEffect, useRef, useState } from "react";

const LazyImage: FC<LazyImagePropertiesType> = (properties) => {
  const {
    src,
    alt,
    className,
    fallback,
    fetchPriority,
    loading = "lazy"
  } = properties;
  const imageReference = useRef<HTMLImageElement>(null);
  const [imageError, setImageError] = useState(false);

  useEffect(() => {
    const reference = imageReference;
    reference.current?.addEventListener(
      "error",
      setImageError.bind(null, true)
    );
    return () => {
      reference.current?.removeEventListener(
        "error",
        setImageError.bind(null, true)
      );
    };
  }, []);

  return (
    <img
      {...pick(properties, "height", "width", "id", "title", "onClick")}
      alt={toString(alt)}
      className={`${className ?? ""} object-cover transition-all`}
      decoding={loading === "eager" ? "auto" : "async"}
      fetchPriority={loading === "eager" ? "high" : fetchPriority}
      itemProp="image"
      loading={loading}
      ref={imageReference}
      src={fallback && (imageError || !src) ? fallback : src}
    />
  );
};

const LazyImageMemoized = memo(LazyImage);
export { LazyImageMemoized as LazyImage };
